{
  "devices_page": {
    "title": "Dispositivos",
    "claim": "Reclamar"
  },
  "device_monitor_page": {
    "title": "Supervisar Dispositivo"
  },
  "device_configuration_page": {
    "title": "Editar Dispositivo"
  },
  "device_create_configuration_page": {
    "title": "Crear Configuración de Dispositivo"
  },
  "device_admin_configuration_page": {
    "title": "Configuración de Administrador de Dispositivo"
  },
  "monitor": {
    "index_title": "Supervisar",
    "default_title": "Nodo %{node_id}",
    "general_info": "Información general",
    "recent_measurements": "Medidas recientes",
    "sensors": "Sensores (%{count})",
    "near_by": "Cerca de <span>%{location}</span>",
    "chart_tab": "Gráfico",
    "table_tab": "Tablero",
    "debug_tab": "Depurar",
    "admin_settings_tab": "Administrador",
    "wind_tab": "Viento",
    "wind_rose_tab": "Rosa de los Vientos",
    "wind_rose_empty_title": "Seleccione parámetros para ver la rosa de los vientos",
    "wind_rose_empty_description": "Elija un parámetro de velocidad del viento y uno de dirección del viento de la lista de la derecha.",
    "wind_rose_speed": "Parámetro de velocidad del viento",
    "wind_rose_direction": "Parámetro de dirección del viento",
    "files_tab": "Archivos",
    "delete": "Eliminar",
    "params": {
      "name": "Parámetro"
    },
    "download_table_data": "Datos de la tabla",
    "download_chart_pdf": "Gráfico (pdf)",
    "download_wind_rose_pdf": "Rosa de los vientos (pdf)",
    "print_chart": "Gráfico impreso",
    "download_chart": "Descargar",
    "toggle_measurements": "Cambiar medidas",
    "live_debug_updates_toggle": "Cambiar las actualizaciones de depuración en vivo",
    "live_debug_updates_stop": "Detener actualizaciones en vivo",
    "live_debug_updates_resume": "Reanudar actualizaciones en vivo",
    "select_measurements": "Seleccionar los parámetros que pueden consultarse",
    "add_to_dashboard": "Agregar al panel de control",
    "hide": "Ocultar parámetro",
    "show": "Mostrar parámetro",
    "manage_parameters_visibility": "Gestionar visibilidad de parámetros"
  },
  "thiamis": {
    "name": "Nombre",
    "description": "Descripción",
    "settings": "Configuración",
    "bat_voltage": "Voltaje Bat.",
    "inventory": "Inventario",
    "device": "Dispositivo",
    "address": "Dirección",
    "parameters": "Parámetros",
    "create": "Crear",
    "more": "...",
    "errors": "Errores",
    "maintenance": "Mantenimiento",
    "status": "Estado",
    "enabled": "Habilitado",
    "debug": "Depurar",
    "driver": "Controlador",
    "driver_default": "Predeterminado",
    "driver_beta": "Beta",
    "calibrations": "Calibraciones",
    "see_wifi_settings": "Ver configuración WiFi del dispositivo",
    "thiamis_module": "Módulo Thiamis",
    "airthinx": "Aethair",
    "select_airthinx": "Seleccionar Aethair",
    "leased_thiamis_module": "Módulo de Thiamis rentado",
    "list_title": "Dispositivo",
    "config_page_title": "Configuración de Dispositivo",
    "config_page_breadcrumb": "Editar",
    "admin_page_breadcrumb": "Administrador",
    "monitor_page_breadcrumb": "Supervisar",
    "node_empty": "el nodo no tiene puntos de datos",
    "not_available_yet": "Aún no está disponible",
    "add_sensor": "Agregar sensor",
    "save": "Guardar",
    "go_to_index": "Regresar a Thiamis",
    "open_monitor": "Supervisar",
    "edit_configuration": "Configuración",
    "delete_thiamis": "Restablecer",
    "create_configuration": "Crear configuración de Thiamis",
    "revoke_lease": "Anular renta",
    "no_leased_shared_orgs": "Thiamis no se compartió o rentó con ninguna organización",
    "choose_node": "Seleccionar nodo...",
    "select_debug_level": "Seleccionar nivel de depuración",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "manually": "Manualmente",
    "add_new_sensor": "Agregar sensor",
    "node_serial": "Número de serie de Thiamis",
    "location": "Ubicación de Thiamis",
    "empty_name": "Nombre de Thiamis",
    "select_network": "Seleccionar red...",
    "empty_description": "Descripción de Thiamis",
    "share_with": "Compartir con",
    "lease_with": "Rentar con",
    "manage_thiamises": "Administrar Thiamis",
    "leased_to_org": "Rentado a %{orgName}",
    "rotate_to_see_graph": "Rotar para ver el registro",
    "map_address_placeholder": "Tipo de dirección o coordenadas...",
    "remove_from_chart": "Remover del registro",
    "billing": "Facturación",
    "owner": "Propietario",
    "external_organization": "Organización externa",
    "unit": "Unidad",
    "profile": "Perfil",
    "debug_info": {
      "timestamp": "Gráfico de fecha",
      "message": "Mensaje"
    },
    "debug_levels": {
      "info": "INFORMACIÓN"
    },
    "pm_config": {
      "dl": "dL",
      "ft": "CFT",
      "m3": "m3"
    },
    "voc_unit": {
      "ppm": "ppm",
      "ppb": "ppb"
    },
    "manage_help_text": "Seleccionar primero thiamis",
    "tooltips": {
      "manage_mode": "Administrar modo encendido/apagado",
      "available_actions": "Acciones",
      "leased_thiamis": "Los Thiamis rentados solo pueden consultarse o configurarse por la organización a la que fueron rentados",
      "location_determined": "Ubicación determinada",
      "location_determined_auto": "Ubicación determinada automáticamente",
      "location_determined_auto_wifi": "Ubicación determinada automáticamente por WiFi",
      "location_determined_manual": "Ubicación determinada manualmente",
      "reset": "Restablecer Thiamis",
      "refresh_wifi_networks": "Actualizar redes WiFi",
      "manage_dialog_transfer_orgazanition": "Es la organización que posee los nodos y puede administrarlos",
      "manage_dialog_transfer_billing_orgazanition": "Es la organización a la que se facturará por el uso de los nodos"
    },
    "default_wifi_dialog": {
      "title": "Configuración WiFi predeterminada",
      "help_text": "En caso de que la red GSM no esté disponible, utilice la siguiente configuración WiFi para configurar su punto de acceso móvil o enrutador para conectar el dispositivo e Internet. Luego puede ingresar o escanear sus credenciales WiFi locales en la consola."
    },
    "manage_dialog": {
      "success": "Dispositivo se %{action} exitosamente",
      "sensor_added": "El sensor se ha añadido exitosamente",
      "error": "Ocurrió un error, inténtelo de nuevo más tarde o póngase en contacto con el soporte de Netronix",
      "share_help_text": "* Tenga en cuenta que no puede compartir el Thiamis que está rentado o que ya fue compartido más de 3 veces.",
      "lease_help_text": "* Tenga en cuenta que después de rentar ese Thiamis no podrá supervisarlo ni configurarlo",
      "remove_share_help_text": "",
      "remove_lease_help_text": "",
      "transfer_help_text": "* Tenga en cuenta que no puede transferir un Thiamis que ya está rentado<br />** La organización de facturación puede ser la misma organización que la organización propietaria o <b>uno de sus socios</b>",
      "reset_help_text": "* Tenga en cuenta que al restablecer Thiamis se eliminará toda la información sobre las veces que lo compartió y rentó",
      "share_error_when_leased": "No puede compartir el Thiamis que ya está rentado",
      "share_error_when_already_shared": "No puede compartir el Thiamis que ya fue compartido más de 3 veces",
      "no_partnerships": "no se encontró ninguna asociación o asociación común",
      "reset_error": "Thiamis no pudo restablecerse, inténtelo de nuevo más tarde o póngase en contacto con el soporte",
      "reset_success": "%{serial} se restableció exitosamente",
      "reset_confirm": "Está a punto de restablecer el dispositivo %{name} [%{serial}]. ¿Está seguro de que desea continuar?"
    },
    "more_info": {
      "nearby": "Cercano",
      "sensors": "Sensores",
      "status": "Estado",
      "battery": "Voltaje de la batería<br />%{value}V",
      "battery_level": "Nivel de batería %{value}%",
      "gsm_signal_with_network": "%{network}<br />Señal GSM<br />%{value}",
      "gsm_signal": "Señal GSM<br />%{value}",
      "gsm_signal_na": "Señal GSM<br />No está disponible",
      "wifi_signal": "%{network}<br />Señal de WiFi %{value}",
      "wifi_signal_na": "Señal de WiFi<br />No está disponible",
      "shared_to": "Compartido con",
      "leased_to": "Rentado",
      "shared_from": "Compartido desde",
      "leased_from": "Rentado desde",
      "last_updated_location": "Última actualización",
      "last_updated": "Último reporte"
    },
    "manage_actions": {
      "share": "Compartir",
      "share_past": "compartido",
      "remove_share": "Dejar de compartir",
      "remove_share_past": "se dejó de compartir",
      "transfer": "Transferir",
      "transfer_past": "transferido",
      "lease": "Rentar",
      "lease_past": "rentado",
      "remove_lease": "Remover la renta",
      "remove_lease_past": "renta removida",
      "download": "Descargar",
      "download_past": "descargado",
      "firmware": "Actualizar Firmware",
      "firmware_past": "firmware actualizado",
      "delete": "Restablecer",
      "delete_past": "restablecer",
      "activate": "Activar",
      "activate_past": "activado",
      "deactivate": "Desactivar",
      "deactivate_past": "desactivado",
      "hibernate": "Hibernar",
      "hibernate_past": "hibernando",
      "payment_update": "Facturar",
      "payment_update_past": "facturación actualizada"
    },
    "view_on_map": "Consultar en el mapa",
    "firmware_channels": {
      "stable": "Estable",
      "unstable": "Inestable",
      "testing": "Probar",
      "tsi": "TSI"
    },
    "states": {
      "activated": "Activado",
      "deactivated": "Desactivado",
      "hibernated": "Hibernando",
      "online": "Informar",
      "offline": "No informar",
      "inventory": "Inventario",
      "leased": "Rentado",
      "shared": "Compartido",
      "excellent": "Excelente",
      "good": "Bueno",
      "satisfactory": "Satisfactorio",
      "moderate": "Moderado",
      "poor": "Pobre",
      "veryPoor": "Muy Pobre"
    },
    "config_tabs": {
      "sensors": "Sensores",
      "general": "General",
      "location": "Ubicación",
      "access_rights": "Permisos de acceso",
      "node_events": "Actividades de Thiamis"
    },
    "sesor_delete_success": "El sensor se eliminó exitosamente",
    "sesor_create_success": "El sensor se creó exitosamente",
    "sesor_update_success": "El sensor se actualizó exitosamente",
    "user_calibration": {
      "params_length": "Los parámetros de calibración deben ser al menos dos",
      "params_format": "Los parámetros de calibración deben ser números separados por comas"
    },
    "location_update_success": "La ubicación se actualizó exitosamente",
    "calibration_update_success": "Calibración VOC %{state}",
    "download_csv": {
      "devices": "Dispositivos",
      "parameters": "Parámetros",
      "from": "Desde",
      "to": "Hasta",
      "parameters_data": "Datos de parámetros",
      "table_data": "Datos de tabla",
      "download": "Descargar datos",
      "export": "Exportar..."
    },
    "manage": {
      "share": "Compartir Dispositivos",
      "remove_share": "Eliminar Compartir de Dispositivos",
      "transfer": "Transferir Dispositivos",
      "lease": "Arrendar Dispositivos",
      "remove_lease": "Eliminar Arriendo de Dispositivos",
      "delete": "Restablecer Dispositivos",
      "activate": "Activar Dispositivos",
      "deactivate": "Desactivar Dispositivos"
    },
    "dashboards": {
      "title": "Paneles",
      "title_private": "Panel Privado",
      "title_public": "Panel Público",
      "enabled": "Panel",
      "title_private_open": "Abrir Panel Privado",
      "title_public_open": "Abrir Panel Público",
      "title_public_open_window": "Abrir en una nueva ventana",
      "pm_units": "PM",
      "temp_units": "Temperatura",
      "temp_132:24_unit": "Fahrenheit (°F)",
      "temp_132:14_unit": "Celsius (°C)",
      "temp_228:12_unit": "Fahrenheit (°F)",
      "temp_228:2_unit": "Celsius (°C)",
      "pm_132:4_unit": "PM1",
      "pm_132:5_unit": "PM2.5",
      "pm_132:6_unit": "PM10",
      "pm_229:1_unit": "PM1",
      "pm_229:2_unit": "PM2.5",
      "pm_229:3_unit": "PM10",
      "voc_units": "VOC",
      "voc_140:11_unit": "EtOH",
      "voc_140:12_unit": "Isobutileno",
      "exposure_time": "Tiempo de Exposición",
      "theme": "Tema",
      "theme_dark": "Oscuro",
      "theme_light": "Claro",
      "show_logo": "Mostrar logotipo de la organización",
      "show_logo_missing_tooltip": "Falta el logotipo de la organización. Por favor, súbelo en la página de edición de la organización."
    },
    "aqms": {
      "title": "AQMS",
      "automation": "AQMS",
      "speed": "Velocidad",
      "dfs": "DFS",
      "devices": "Dispositivos Conectados",
      "cron": "Programador",
      "no_template": "No se encontró plantilla para AQMS"
    }
  },
  "sensor": {
    "title": "Sensor",
    "type": "Tipo de Sensor",
    "stel_alert_conf": "Configuración de la alarma de STEL",
    "speed_min_label": "Apagado",
    "speed_max_label": "100%",
    "auto_zero_min_label": "Desactivado",
    "auto_zero_max_label": "24h",
    "auto_zero_btn": "Cero automático",
    "add_statistics": "Agregar estadísticas",
    "configure_channels": "Configurar canales",
    "channel": "Canal",
    "select_channel": "Seleccionar canal",
    "factory_calibration_profiles": "Perfiles calibrados de fábrica",
    "no_added": "No hay sensores agregados",
    "add_custom_calibration": "Calibración Personalizada",
    "data_point": {
      "last_measurement": "Última medida",
      "calibration_params": "Parámetros de Calibración",
      "result": "Después",
      "value": "Antes",
      "id": "Punto de datos",
      "name": "Nombre",
      "func": "Función",
      "period": "Periodo",
      "interval": "Intervalo",
      "unit": "Unidad",
      "min": "Min",
      "max": "Max",
      "remove_title": "Remover parámetro estadístico",
      "add_title": "Agregar parámetro estadístico",
      "add_info": "Se calcula a partir de un parámetro existente y se recalcula cada minuto desde el momento en que se crea; no hay valores anteriores.",
      "add_info_items": [
        "**AVG**: promedio móvil sobre el periodo seleccionado.",
        "**MAX** / **MIN**: máximo / mínimo móvil sobre el periodo seleccionado.",
        "**DIFF**: diferencia entre dos parámetros en cada lectura, incluso de dispositivos distintos (sin periodo).",
        "Los periodos de 6 horas o más se recalculan cada hora."
      ],
      "remove_calibration_title": "Eliminar Parámetro de Calibración",
      "add_custom_calibration_title": "Añadir Parámetro de Calibración Personalizada",
      "add_scale_title": "Configurar medida para %{channel_name} (%{conf})",
      "add_link_title": "Configurar medida para %{channel_name}",
      "add_scale_title_wo_channel": "Configurar medida",
      "id_placeholder": "Seleccionar punto de datos...",
      "func_placeholder": "Seleccionar función...",
      "period_placeholder": "Seleccionar periodo...",
      "interval_placeholder": "Seleccionar intervalo..."
    },
    "configuration": {
      "photometric_calibration": "Calibración fotométrica",
      "auto_zero_interval": "Intervalo de cero automático",
      "debug": "Depurar",
      "size_correction": "Calibración del tamaño",
      "flow_calibration": "Calibración del flujo",
      "calfactor": "Calibración del valor",
      "pm1_stel_alert": "PM 1",
      "pm25_stel_alert": "PM 2.5",
      "pm4_stel_alert": "PM 4",
      "pm10_stel_alert": "PM 10",
      "total_stel_alert": "Total",
      "stel_alert_unit": "mg/m<sup>3</sup>",
      "enabled": "Estado",
      "calibrate": "Calibrar",
      "calibration": "Calibración",
      "calibration_voc": "Calibración VOC",
      "firmware": "Firmware",
      "auto_zero": "Cero automático",
      "cumulative_concentration_calibration": "Concentración acumulada<br /><small>(calibración)</small>",
      "pump_run_time": "Tiempo de funcionamiento de la bomba",
      "fan_dac_value": "Valor DAC del ventilador",
      "laser_dac_value": "Valor DAC del láser",
      "filter_last_changed": " Filtro cambiado",
      "cumulative_concentration_filter_change": "Concentración acumulada<br /><small>(cambio de filtro)</small>",
      "mode": "Modo",
      "sample_method": "Método de muestreo",
      "instrument_mode": "Modo de instrumento",
      "exp_bd_status_alarm": "Estado de la alarma i/o EXP. BD.",
      "mib_status_alarm": "Estado de la alarma MIB",
      "motherboard_status_alarm": "Estado de la alarma de la tarjeta madre",
      "external_alarm_3": "Alarma externa 3",
      "external_alarm_2": "Alarma externa 2",
      "external_alarm_1": "Alarma externa 1",
      "filters": "Filtros",
      "profile": "Perfil",
      "choose_profile": "Seleccionar perfil",
      "measurement_mode": "Modo de medida",
      "units": "Unidad",
      "channel_n": "Canal %{i}",
      "session_time": "Tiempo de la sesión",
      "temperature_unit": "Unidad de temperatura",
      "windspeed_unit": "Unidad de la velocidad del viento",
      "pressure_unit": "Unidad de presión",
      "precipitation_unit": "Unidad de precipitación",
      "pm_microgram": "PM Unidad",
      "us_units": "Unidades imperiales",
      "pm_ug_label": "µg",
      "pm_mg_label": "mg",
      "iccid": "ICCID",
      "imei": "IMEI",
      "mac": "MAC"
    },
    "profiles": {
      "mcerts": "MCERTS",
      "custom": "Personalizado",
      "factory": "Valores predeterminados de fábrica",
      "ambient": "Ambiente"
    },
    "tooltips": {
      "profile": "La configuración se aplicará en el perfil seleccionado"
    }
  },
  "sensors": {
    "remove_sensor": "remover sensor",
    "no_serial": "# No hay número de seríe"
  },
  "data_points": {
    "status_true": "Informar",
    "status_OK": "Online",
    "status_false": "No informar"
  },
  "devices": {
    "navigation_title": "Dispositivos",
    "title": "Dispositivos",
    "not_found": "No se encontraron resultados",
    "actions": {
      "title": "Acciones",
      "download": "Descargar",
      "table_data": "Datos de tabla",
      "parameters_data": "Datos de parámetros",
      "devices": "Dispositivos"
    },
    "statuses": {
      "ok": "Informar",
      "disabled": "Deshabilitado",
      "error": "Error",
      "empty": "Sin estado",
      "activated": "Activado",
      "deactivated": "Desactivado",
      "hibernated": "Hibernando",
      "online": "Informar",
      "offline": "No informar",
      "excellent": "Excelente",
      "good": "Bueno",
      "satisfactory": "Satisfactorio",
      "moderate": "Moderado",
      "poor": "Pobre",
      "veryPoor": "Muy Pobre"
    }
  },
  "nodes": {
    "choose_node": "Seleccionar nodo...",
    "node_serial": "Número de serie del nodo"
  },
  "claim": {
    "serials": "Números de serie",
    "organization": "Organización",
    "result": "Resultado",
    "serials_helper": "Use espacio, coma o nueva línea para reclamación por lotes",
    "claim_devices": "Reclamar dispositivos",
    "claiming_devices": "Reclamando...",
    "serial": "Número de serie",
    "status": "Estado",
    "claimed": "Reclamado",
    "failed": "Fallido",
    "no_claimed_devices": "No hay dispositivos reclamados en su organización. Reclame el/los dispositivo(s) y aparecerá(n) aquí.",
    "success_claim": "¡Los dispositivos han sido reclamados exitosamente!",
    "warning_claim": "Ocurrió un error al reclamar algunos de los dispositivos.",
    "error_claim": "¡Ocurrió un error al reclamar dispositivos!"
  }
}